import React, { Component } from 'react';
// import './App.css';

class About extends Component {
  render() {
    return (
      <div className="about">
        <div className="banner">
          <div className="quote">
            <h3>You should have been here yesterday..</h3>
          </div>
          {/* <div className="unsplash">
            <a href="https://unsplash.com/@jeremybishop?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge" target="_blank" rel="noopener noreferrer" title="Download free do whatever you want high-resolution photos from Jeremy Bishop">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><title>unsplash-logo</title><path d="M20.8 18.1c0 2.7-2.2 4.8-4.8 4.8s-4.8-2.1-4.8-4.8c0-2.7 2.2-4.8 4.8-4.8 2.7.1 4.8 2.2 4.8 4.8zm11.2-7.4v14.9c0 2.3-1.9 4.3-4.3 4.3h-23.4c-2.4 0-4.3-1.9-4.3-4.3v-15c0-2.3 1.9-4.3 4.3-4.3h3.7l.8-2.3c.4-1.1 1.7-2 2.9-2h8.6c1.2 0 2.5.9 2.9 2l.8 2.4h3.7c2.4 0 4.3 1.9 4.3 4.3zm-8.6 7.5c0-4.1-3.3-7.5-7.5-7.5-4.1 0-7.5 3.4-7.5 7.5s3.3 7.5 7.5 7.5c4.2-.1 7.5-3.4 7.5-7.5z"></path></svg>
              </span>
              <span>Jeremy Bishop</span>
            </a>
          </div> */}
        </div>
        <div className="photoCredit">
          Photo credit: <a href="https://unsplash.com/@jeremybishop?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge" target="_blank" rel="noopener noreferrer">Jeremy Bishop</a>
        </div>
        <div className="content">
          <p>
            Je kent het wel; net die ene topdag gemist omdat je weer iets anders aan het doen was. Iedereen heeft het over
            die hoge bakken of eindeloze lijntjes, maar jij bent een dag te laat; "you should have been here yesterday!"
            <span role="img" aria-label="Crying Face">😢</span>.
          </p>
          <p>
            Daar komt nu een einde aan! SurfAlert is de nieuwe waarschuwings service die laat zien wanneer je moet gaan surfen.
            Real-time meetgegevens laten je zien hoe hoog de golven op dat moment zijn, dus geen voorspellingen maar echt data!
          </p>
          <p>
            Omdat de dienst nog volop in ontwikkeling is zullen er regelmatig updates komen om de beste alert van NL te bouwen.
          </p>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/Components/About.jsx